const Sidebar = {
    title: 'My Portfolio',
    myName: 'Ryan Afrizal',
    button: [
        {
            name: 'Home',
            to: '/'
        },
        {
            name: 'Skill',
            to: '/skill'
        },
        {
            name: 'My Project',
            to: '/project'
        }
    ]
}

export default Sidebar